export default function cardWidget14() {
  const widgetName = 'cardWidget14';
  const widgetOpts = cardWidget14Opts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'cardWidget14-container-wrapper';

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: false,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.wrap(
          `<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`,
        );
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
          </div>`);

      if (URL) {
        $cardItem.attr('target', '_blank');
      } else {
        $cardItem.removeAttr('href');
      }
    });
  }
}
